import type { OtelResource } from './basic-otel-compat.js'

declare global {
  var APP_VERSION: string
}

function formatLocalVersion(value: unknown): string {
  if (!value) return 'Unknown app version'

  // New format: { ts: number, sha: string }
  if (typeof value === 'object') {
    try {
      const maybe = value as { ts?: unknown; sha?: unknown }
      const ts = typeof maybe.ts === 'number' ? maybe.ts : Number(maybe.ts)
      const sha = typeof maybe.sha === 'string' ? maybe.sha : ''
      if (!Number.isFinite(ts)) return 'Unknown app version'
      const d = new Date(ts)
      const pad = (n: number) => String(n).padStart(2, '0')
      const dd = pad(d.getDate())
      const MM = pad(d.getMonth() + 1)
      const YY = String(d.getFullYear()).slice(-2)
      const hh = pad(d.getHours())
      const mm = pad(d.getMinutes())
      const time = `${hh}:${mm} ${dd}.${MM}.${YY}`
      return sha ? `${time} ${sha}` : time
    } catch {
      return 'Unknown app version'
    }
  }

  // Legacy format: already a displayable string
  if (typeof value === 'string') return value

  return 'Unknown app version'
}

// Produce a stable string for UI and telemetry
globalThis.APP_VERSION = formatLocalVersion(
  typeof APP_VERSION === 'undefined' ? undefined : (APP_VERSION as unknown),
)

export const makeTelResource = (d: Omit<OtelResource, 'version'>): OtelResource => ({
  ...d,
  version: globalThis.APP_VERSION,
})
